'use client';
import styled from 'styled-components';

export const StyledIllustrationPills = styled.div`
  overflow: scroll;
  width: 100%;
  /* Height & spacing equates to 100px */
  min-height: ${props => props.theme.spacing(25)};
  display: grid;
  align-items: center;
  background-color: ${props =>
    props.theme.colors.get(
      props.$backgroundColor,
      props.theme.colors.background.base,
    )};
  padding: ${props => props.theme.spacing(4)};
  margin-top: ${props => props.theme.spacing(4)};
`;

export const StyledIllustrationPillsCRO = styled.div`
  width: 100%;
  /* Height & spacing equates to 100px */
  min-height: ${props => props.theme.spacing(25)};
  display: grid;
  align-items: center;
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  margin: ${props => props.theme.spacing(4, 0)};
  margin-bottom: ${props => props.theme.spacing(11)};
`;

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  justify-items: center;
  gap: ${props => props.theme.spacing(3)};
  margin: auto;
  max-width: 100%;
`;
